import React, {useEffect, useState} from 'react';
import Layout from "../components/layout/Layout";
import {NumericFormat} from "react-number-format";
import jaceToken from '../assets/images/jace-token.svg';
import {Link} from "react-router-dom";
import {useShallowPickSelector} from "../redux";
import PayoutDialog from "./affiliate/payout";
import axios from "axios";
import {baseUrl} from "../api/network";
import * as AppStore from "../redux/app";
import {toast} from "react-toastify";
import toastOptions from "../data/ToastOptions";
import {useDispatch} from "react-redux";
import Lottie from "react-lottie";
import shine from "../assets/animations/shine.json";

const Checkout = () => {
    const {mainData} = useShallowPickSelector('app', ['mainData']);
    const {tgUser} = useShallowPickSelector('user', ['tgUser']);
    const [showPayoutDialog, setShowPayoutDialog] = useState(false);
    const dispatch = useDispatch();
    const [celebrateLoader, setCelebrateLoader] = useState(false);
    const [celebrateLoader1, setCelebrateLoader1] = useState(false);

    const onClaimCommissionPressFn = () => {
        if (Number(mainData?.current_commissions) > 0) {
            setCelebrateLoader1(true)
            const headers = {
                'Content-Type': 'application/json',
            }

            axios.get(`${baseUrl}/affiliate/claim/commissions?user_tg_id=${tgUser?.id}`,{headers})
                .then(response => {
                    if (response.data.status === '1') {
                        dispatch(AppStore.getPointsDataFn())
                        dispatch(AppStore.actions.setShowCelebrate(true))
                        setCelebrateLoader1(false)
                    } else {
                        setCelebrateLoader1(false)
                        toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 13});
                    }
                })
                .catch(() => {
                    setCelebrateLoader1(false)
                    toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 14});
                })
        }
    }

    const setOpenFn = () => {
        setShowPayoutDialog(false);
    }

    const celebrate = () => {
        if (Number(mainData?.current_points) > 0) {
            setCelebrateLoader(true)
            const headers = {
                'Content-Type': 'application/json',
            }

            axios.get(`${baseUrl}/points/claim?user_tg_id=${tgUser?.id}`,{headers})
                .then(response => {
                    if (response.data.status === '1') {
                        dispatch(AppStore.getPointsDataFn())
                        dispatch(AppStore.actions.setShowCelebrate(true))
                        setCelebrateLoader(false)
                    } else {
                        setCelebrateLoader(false)
                        toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 15});
                    }
                })
                .catch(() => {
                    setCelebrateLoader(false)
                    toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 16});
                })
        }
    }

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: shine,
        isClickToPauseDisabled: true,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className="container">
            <div className="checkout-taskContainer">
                <div className="checkout-dataContainer">
                    {/* <div className="checkout-dataSection">
                        <p className="text-white fs14">Your Commission</p>
                        <div className="left">
                            <NumericFormat
                                value={mainData?.current_commissions ? `${mainData?.current_commissions}` : 0.00}
                                thousandSeparator=","
                                displayType="text"
                                title={mainData?.current_commissions ? `${mainData?.current_commissions}` : 0.00}
                                className="fs30 text-white lineNumber1 wUnset"
                            />
                            <p className="text-green fs24 ml10">USDT</p>
                        </div>
                    </div> */}
                    <div className="checkout-dataSection">
                        <p className="text-white fs14">Your $JETs ready to launch</p>
                        <div className="left">
                            <img alt="Jet Token" src={jaceToken} className="jetIcon mb5 mr10" />
                            <div className="w100 center relative">
                                <NumericFormat
                                    value={mainData?.current_jets ?? '0'}
                                    thousandSeparator=","
                                    displayType="text"
                                    title={mainData?.current_jets ? mainData?.current_jets?.toString() : '0'}
                                    className="fs30 text-white lineNumber1 wUnset"
                                />
                                <p className="text-orange fs24 ml10">$JETs</p>
                                {!!mainData?.current_jets && Number(mainData?.current_jets) > 0 && <div className="absolute w100 h100 r0 t0">
                                    <Lottie
                                        isClickToPauseDisabled={true}
                                        options={defaultOptions}
                                        height="100%"
                                        width="100%"
                                        eventListeners={[
                                            {
                                                eventName: 'complete',
                                                callback: () => dispatch(AppStore.actions.setShowCelebrate(false)),
                                            },
                                        ]}/>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="checkout-box mt40">
                    <div className="checkout-leftBox maxW300 minW50">
                        <p className="text-white fs14">JPs<span className="text-orange"> Ready to Convert</span></p>
                        <div className="left w100">
                            <NumericFormat
                                value={mainData?.current_points ?? '0'}
                                thousandSeparator=","
                                displayType="text"
                                title={mainData?.current_points ? mainData?.current_points?.toString() : '0'}
                                className="fs24 text-white lineNumber1 maxW200"
                            />
                            <p className="text-orange fs16 mb5 ml10 nowrap">Jet Points</p>
                        </div>
                    </div>
                    <button type="button" className={`button2 wUnset fw400 fs14 py20 my10 checkout-ml10 maxW200 pointer relative ${Number(mainData?.current_points) > 0 ? '' : 'disabledBtn'}`} disabled={Number(mainData?.current_points) < 1 || celebrateLoader} onClick={celebrate}>
                        <span className="text-white lineNumber1 minW50">Convert to $JETs</span>
                        {celebrateLoader && <div className="center loaderInBtn loaderInBtn1">
                            <div className="loader"></div>
                        </div>}
                    </button>
                </div>
                <div className="checkout-box relative">
                    <div className="checkout-leftBox maxW300 minW50">
                        <p className="text-white fs14">CPs <span className="text-orange"> Ready to Convert</span></p>
                        <div className="left w100">
                            <NumericFormat
                                value={mainData?.current_commissions ? `${mainData?.current_commissions}` : '0'}
                                thousandSeparator=","
                                displayType="text"
                                title={mainData?.current_commissions ? `${mainData?.current_commissions}` : '0'}
                                className="fs24 text-white lineNumber1 maxW200"
                            />
                            <p className="text-green fs16 mb5 ml10 nowrap">Commission Points</p>
                        </div>
                    </div>
                    <button type="button" className={`button1 wUnset fw400 fs14 py20 my10 checkout-ml10 maxW200 pointer relative ${Number(mainData?.current_commissions) > 0 ? '' : 'disabledBtn'}`} disabled={Number(mainData?.commission) < 1 || celebrateLoader1} onClick={onClaimCommissionPressFn}>
                        <span className="text-white lineNumber1 minW50">Convert to $JETs</span>
                        {celebrateLoader1 && <div className="center loaderInBtn loaderInBtn3">
                            <div className="loader"></div>
                        </div>}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Checkout;
